import React from 'react';
import ReactModal from 'react-modal';
import { Link } from 'react-router-dom';
import testingicon from  '../../assets/images/icon-tuition.png';
import myCCOpro from '../../assets/images/icon-mycco.png';
const MobileAccountModal = ({
  isOpen,
  onClose,
  activeAccount,
  handleLogoutRedirect,
  t,
}) => {
  const customStyles = {
    content: {
      position: 'fixed',
      bottom: '0',
      left: '0',
      right: '0',
      padding: '20px',
      backgroundColor: '#fff',
      boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.1)',
      border: 'none',
      borderRadius: '10px 10px 0 0',
      maxHeight: '80vh',
      overflowY: 'auto',
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1000,
    },
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={customStyles}
      closeTimeoutMS={300}
      ariaHideApp={false}
      className="animate-bottom"
    >
      <div className="cco_dropdown_content"  >
        <div className="cco_text cco_text_4_1">
          <div className="cco_text_inner">{t('header.roleManagement')}</div>
        </div>
        <ul className="cco_menu cco_menu_1_1">
                  <li style={{ borderTop: '1px solid #ddd', paddingTop: '3px', marginTop: '4px' }}>
         <Link
           to="/testing-personnel"
           state={activeAccount}
           style={{ 
             fontSize: '14px', 
             display: 'flex', 
             alignItems: 'center'
             ,
             color:'black'
           }}
         >
           <img
             src={testingicon}
             alt="Testing Personnel"
             style={{ marginLeft: '13px', height: '17px', width: '17px', marginRight: '7px' }}
           />
           {t('header.testingPersonel')}
         </Link>
       </li>
       
       
                     {/* <li style={{ borderTop: '1px solid #ddd', paddingTop: '3px', marginTop: '4px' }}>
                       <Link to="/myCCOpro" state={activeAccount} style={{ fontSize: '14px', display: 'flex', alignItems: 'center',color:'black' }}>
                       <img
               src={myCCOpro}
               alt="mycco pro"
               style={{ marginLeft: '13px', height: '18px', width: '18px', marginRight: '7px' }}
             />
                         CCO Pro
                       </Link>
                     </li> */}
        </ul>
        <div className="cco_text cco_text_4_1">
          <div className="cco_text_inner">{t('header.accountManagement')}</div>
        </div>
        <ul className="cco_menu cco_menu_1_1">
          <li className="cco_menu_item cco_menu_item_icon_gear">
            <Link
              to="/account"
              state={activeAccount}
              onClick={onClose} // Close modal on click
            >
              {t('header.accountDetails')}
            </Link>
          </li>
          <li className="cco_menu_item cco_menu_item_icon_logout">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleLogoutRedirect();
                onClose(); // Close modal after logout
              }}
            >
              {t('header.signout')}
            </a>
          </li>
        </ul>
      </div>
    </ReactModal>
  );
};

export default MobileAccountModal;
